import { Box, styled } from '@mui/material'
import { colors } from '@theme/variables'

export const Root = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 36px;
  padding: 12px 16px
    ${({ $withAdditionalPadding }: { $withAdditionalPadding: boolean }) => ($withAdditionalPadding ? ' 60px' : '')};
  background-color: ${colors.white};
  border-top: 1px solid ${colors.lightGrey};
`

export const FooterItem = styled('a')`
  position: relative;
  font-size: 14px;
  text-decoration: none;
  color: ${colors.black};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: -18px;
    height: 20px;
    width: 1px;
    background-color: ${colors.lightGrey};
  }

  &:last-child::before {
    display: none;
  }
`
